export const TOGGLE_MODE_BUTTON_WIDTH = '2.5rem';
